// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"c72d47b4","942":"6f1ce66b"}[chunkId] + ".chunk.js";
};